/* ============================================================
   PRETTY SMART VOCAB — the app
   Built by build_shopify.py from the published artifact.
   Do not edit this file by hand, regenerate it.

   Everything renders inside a shadow root, so the store's theme cannot
   reach in and the app's very generic class names cannot leak out.
   ============================================================ */
(function () {
  'use strict';

  var CSS  = "\n:host{\n  display:block;\n  --paper:#fdf6f8; --paper-2:#fbecf1;\n  --card:#ffffff; --card-2:#fdeef3;\n  --ink:#3a2731; --ink-2:#6d5563; --ink-3:#9d8592;\n  --line:#f2dde5; --line-2:#e6c8d4;\n  --accent:#d92b63; --accent-deep:#a81a4a; --accent-soft:#fbdde7;\n  --plum:#7b4b8a;\n  --good:#1f8a63; --good-soft:#ddf3ea;\n  --warn:#bd6014; --warn-soft:#fceada;\n  --mixer:#ffffff; --vibe-mix:100%;\n  --shadow:0 1px 2px rgba(120,50,80,.05), 0 10px 26px -16px rgba(120,50,80,.35);\n  --shadow-lift:0 2px 4px rgba(120,50,80,.07), 0 18px 40px -18px rgba(120,50,80,.4);\n  --r:14px;\n  --display:\"Fraunces\",Georgia,\"Times New Roman\",serif;\n  --body:\"Karla\",\"Helvetica Neue\",Arial,sans-serif;\n  --mono:\"DM Mono\",\"SFMono-Regular\",Consolas,monospace;\n}\n@media (prefers-color-scheme:dark){\n  :host(:not([data-theme=\"light\"])){\n    --paper:#191118; --paper-2:#221722;\n    --card:#241a22; --card-2:#2e2029;\n    --ink:#f7e9ef; --ink-2:#cbb1bd; --ink-3:#977e8b;\n    --line:#382831; --line-2:#4a3540;\n    --accent:#ff6f9c; --accent-deep:#ff8fb2; --accent-soft:#3d2030;\n    --plum:#c79ad4;\n    --good:#5fd3a3; --good-soft:#15342a;\n    --warn:#f0a35c; --warn-soft:#3a2615;\n    --mixer:#ffffff; --vibe-mix:62%;\n    --shadow:0 1px 2px rgba(0,0,0,.3), 0 10px 26px -16px rgba(0,0,0,.8);\n    --shadow-lift:0 2px 4px rgba(0,0,0,.35), 0 18px 40px -18px rgba(0,0,0,.9);\n  }\n}\n:host([data-theme=\"dark\"]){\n  --paper:#191118; --paper-2:#221722;\n  --card:#241a22; --card-2:#2e2029;\n  --ink:#f7e9ef; --ink-2:#cbb1bd; --ink-3:#977e8b;\n  --line:#382831; --line-2:#4a3540;\n  --accent:#ff6f9c; --accent-deep:#ff8fb2; --accent-soft:#3d2030;\n  --plum:#c79ad4;\n  --good:#5fd3a3; --good-soft:#15342a;\n  --warn:#f0a35c; --warn-soft:#3a2615;\n  --mixer:#ffffff; --vibe-mix:62%;\n  --shadow:0 1px 2px rgba(0,0,0,.3), 0 10px 26px -16px rgba(0,0,0,.8);\n  --shadow-lift:0 2px 4px rgba(0,0,0,.35), 0 18px 40px -18px rgba(0,0,0,.9);\n}\n\n*{box-sizing:border-box}\n:host{\n  margin:0; background:var(--paper); color:var(--ink);\n  font-family:var(--body); font-size:15px; line-height:1.55;\n  -webkit-font-smoothing:antialiased;\n}\n::selection{background:var(--accent-soft); color:var(--accent-deep)}\n:focus-visible{outline:2.5px solid var(--accent); outline-offset:2px; border-radius:6px}\n\n.wrap{max-width:1120px; margin:0 auto; padding:0 20px 90px}\n\n/* ---------------------------------------------------------- masthead */\n.masthead{padding:38px 0 26px; display:grid; gap:16px}\n.eyebrow{\n  font-family:var(--mono); font-size:11px; letter-spacing:.18em;\n  text-transform:uppercase; color:var(--accent); margin:0;\n}\nh1{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 144;\n  font-weight:600; font-size:clamp(38px,7vw,66px); line-height:.95;\n  margin:0; letter-spacing:-.015em; text-wrap:balance;\n}\nh1 em{font-style:italic; color:var(--accent); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 144}\n.dek{margin:0; max-width:60ch; color:var(--ink-2); font-size:16px}\n\n.statrow{display:flex; flex-wrap:wrap; gap:10px; align-items:stretch; margin-top:4px}\n.stat{\n  background:var(--card); border:1px solid var(--line); border-radius:var(--r);\n  padding:10px 15px; display:flex; align-items:baseline; gap:8px;\n}\n.stat b{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 60;\n  font-size:22px; font-weight:600; font-variant-numeric:tabular-nums;\n}\n.stat span{font-size:12px; color:var(--ink-3); letter-spacing:.03em}\n.stat.live{border-color:var(--line-2); background:var(--card-2)}\n.stat.live b{color:var(--accent)}\n.stat.live.warn{border-color:color-mix(in srgb,var(--warn) 34%,transparent); background:var(--warn-soft)}\n.stat.live.warn b{color:var(--warn)}\n.tab .bar{display:block; height:3px; border-radius:99px; background:var(--line); margin-top:5px; overflow:hidden}\n.tab .bar i{display:block; height:100%; background:var(--tabc); transition:width .3s ease}\n.drill{max-width:620px; display:grid; gap:14px}\n.timer{\n  display:flex; align-items:center; gap:12px; background:var(--card);\n  border:1px solid var(--line); border-radius:var(--r); padding:12px 16px;\n}\n.timer .big{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 60;\n  font-size:34px; font-weight:600; font-variant-numeric:tabular-nums; line-height:1;\n  min-width:62px;\n}\n.timer .big.low{color:var(--warn)}\n.timer .lbl{font-family:var(--mono); font-size:10px; letter-spacing:.12em; text-transform:uppercase; color:var(--ink-3)}\n.timer .sc{margin-left:auto; text-align:right}\n.timer .sc b{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 60;\n  font-size:26px; font-weight:600; color:var(--accent); display:block; line-height:1;\n}\n.prompt{\n  background:var(--card); border:1px solid var(--line); border-radius:var(--r);\n  padding:24px 22px; text-align:center; box-shadow:var(--shadow);\n}\n.prompt .lbl{font-family:var(--mono); font-size:10px; letter-spacing:.12em; text-transform:uppercase; color:var(--ink-3)}\n.prompt .txt{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 90;\n  font-size:clamp(22px,4.4vw,32px); font-weight:600; line-height:1.2; margin-top:8px; text-wrap:balance;\n}\n.wordopts{display:grid; grid-template-columns:1fr 1fr; gap:8px}\n.wopt{\n  border:1px solid var(--line-2); background:var(--card); color:var(--ink); font:inherit;\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n  font-size:19px; font-weight:600; padding:14px 12px; border-radius:12px; cursor:pointer;\n  transition:all .12s ease;\n}\n.wopt:hover:not(:disabled){border-color:var(--accent); background:var(--accent-soft)}\n.wopt.right{background:var(--good-soft); border-color:var(--good)}\n.wopt.wrong{background:var(--warn-soft); border-color:var(--warn)}\n.misscard{\n  --vibe:var(--warn);\n  background:var(--card); border:1px solid var(--line); border-left:4px solid var(--warn);\n  border-radius:0 var(--r) var(--r) 0; padding:13px 15px;\n}\n.misscard .whead{padding-left:0}\n.missn{\n  font-family:var(--mono); font-size:10px; letter-spacing:.06em; text-transform:uppercase;\n  background:var(--warn-soft); color:var(--warn); padding:1.5px 7px; border-radius:5px; margin-left:auto;\n}\n\n/* ---------------------------------------------------------- set tabs */\n.spine{\n  display:flex; flex-wrap:wrap; gap:6px; padding:4px 4px 12px;\n  margin:8px -4px 0;\n}\n.tab{\n  flex:0 0 auto; cursor:pointer; border:1px solid var(--line);\n  background:var(--card); color:var(--ink-2);\n  border-radius:11px 11px 4px 4px; padding:8px 13px 9px;\n  font:inherit; font-size:13px; text-align:left; line-height:1.25;\n  transition:transform .16s ease, box-shadow .16s ease, background .16s ease;\n  border-bottom:3px solid var(--tabc,var(--line-2));\n}\n.tab:hover{transform:translateY(-2px); box-shadow:var(--shadow)}\n.tab b{display:block; font-weight:700; color:var(--ink); font-size:13px}\n.tab i{font-style:normal; font-family:var(--mono); font-size:10.5px; color:var(--ink-3); letter-spacing:.01em}\n.tab[aria-pressed=\"true\"]{\n  background:var(--card-2); color:var(--ink);\n  border-color:var(--tabc); border-bottom-width:3px;\n  box-shadow:var(--shadow-lift); transform:translateY(-2px);\n}\n.tab.wide b{color:var(--accent)}\n\n/* ---------------------------------------------------------- toolbar */\n.toolbar{\n  display:flex; flex-wrap:wrap; gap:10px; align-items:center;\n  padding:14px 0 18px; border-top:1px solid var(--line);\n}\n.modes{display:flex; gap:4px; background:var(--paper-2); padding:4px; border-radius:11px; border:1px solid var(--line)}\n.mode{\n  border:0; background:transparent; font:inherit; font-size:13px; font-weight:600;\n  color:var(--ink-2); padding:7px 13px; border-radius:8px; cursor:pointer;\n  transition:background .15s ease, color .15s ease;\n}\n.mode:hover{color:var(--ink)}\n.mode[aria-pressed=\"true\"]{background:var(--card); color:var(--accent); box-shadow:var(--shadow)}\n.grow{flex:1 1 auto}\n.field{\n  display:flex; align-items:center; gap:7px; background:var(--card);\n  border:1px solid var(--line); border-radius:10px; padding:7px 12px; min-width:190px;\n}\n.field input{border:0; background:transparent; font:inherit; font-size:13.5px; color:var(--ink); width:100%; outline:0}\n.field input::placeholder{color:var(--ink-3)}\n.field svg{flex:0 0 auto; color:var(--ink-3)}\n\n.btn{\n  border:1px solid var(--line-2); background:var(--card); color:var(--ink);\n  font:inherit; font-size:13px; font-weight:600; padding:8px 14px;\n  border-radius:10px; cursor:pointer; transition:all .15s ease;\n}\n.btn:hover{border-color:var(--accent); color:var(--accent)}\n.btn.primary{background:var(--accent); border-color:var(--accent); color:#fff}\n.btn.primary:hover{background:var(--accent-deep); border-color:var(--accent-deep); color:#fff}\n:host([data-theme=\"dark\"]) .btn.primary,\n.btn.primary{color:#fff}\n@media (prefers-color-scheme:dark){:host(:not([data-theme=\"light\"])) .btn.primary{color:#2a0d18}}\n:host([data-theme=\"dark\"]) .btn.primary{color:#2a0d18}\n\n/* ---------------------------------------------------------- vibe chips */\n.vibebar{display:flex; flex-wrap:wrap; gap:6px; padding:0 0 20px}\n.vchip{\n  --vibe:var(--ink-3);\n  --vibe-fg:color-mix(in srgb, var(--vibe) var(--vibe-mix), var(--mixer));\n  border:1px solid color-mix(in srgb, var(--vibe) 26%, transparent);\n  background:color-mix(in srgb, var(--vibe) 9%, var(--card));\n  color:var(--vibe-fg); font:inherit; font-size:12px; font-weight:600;\n  padding:5px 11px; border-radius:999px; cursor:pointer; transition:all .15s ease;\n  display:inline-flex; align-items:center; gap:5px;\n}\n.vchip:hover{border-color:var(--vibe)}\n.vchip[aria-pressed=\"true\"]{background:color-mix(in srgb, var(--vibe) 20%, var(--card)); border-color:var(--vibe); box-shadow:var(--shadow)}\n.vchip u{text-decoration:none; font-family:var(--mono); font-size:10.5px; opacity:.75; font-weight:400}\n\n/* ---------------------------------------------------------- word cards */\n.cards{display:grid; grid-template-columns:repeat(auto-fill,minmax(295px,1fr)); gap:12px}\n.card{\n  --vibe:var(--ink-3);\n  --vibe-fg:color-mix(in srgb, var(--vibe) var(--vibe-mix), var(--mixer));\n  background:var(--card); border:1px solid var(--line); border-radius:var(--r);\n  padding:15px 16px 14px; position:relative; overflow:hidden;\n  transition:box-shadow .18s ease, border-color .18s ease;\n}\n.card::before{content:\"\"; position:absolute; inset:0 auto 0 0; width:4px; background:var(--vibe); opacity:.85}\n.card:hover{box-shadow:var(--shadow); border-color:var(--line-2)}\n.card.known{background:var(--good-soft); border-color:color-mix(in srgb, var(--good) 34%, transparent)}\n.whead{display:flex; align-items:baseline; gap:8px; flex-wrap:wrap; padding-left:8px}\n.word{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n  font-size:23px; font-weight:600; line-height:1.1; letter-spacing:-.01em;\n}\n.pos{font-family:var(--mono); font-size:11px; color:var(--ink-3); font-style:italic}\n.pol{\n  font-family:var(--mono); font-size:10px; letter-spacing:.06em; text-transform:uppercase;\n  padding:1.5px 6px; border-radius:5px; margin-left:auto;\n}\n.pol.pos{background:var(--good-soft); color:var(--good); font-style:normal}\n.pol.neg{background:var(--warn-soft); color:var(--warn); font-style:normal}\n.pol.mid{background:var(--paper-2); color:var(--ink-3); font-style:normal}\n.def{margin:7px 0 0; padding-left:8px; font-size:14.5px; color:var(--ink); font-weight:500}\n.def2{margin:3px 0 0; padding-left:8px; font-size:13.5px; color:var(--ink-2)}\n.def2 i{font-family:var(--mono); font-size:11px; font-style:italic; color:var(--ink-3)}\n.ex{\n  margin:11px 0 0; padding:9px 11px 9px 12px; border-radius:9px;\n  background:var(--paper-2); font-size:13px; color:var(--ink-2); line-height:1.5;\n}\n.ex mark{background:color-mix(in srgb, var(--vibe) 24%, transparent); color:var(--ink); font-weight:700; padding:1px 2px; margin:0 -1px; border-radius:4px}\n.extras{\n  display:grid; gap:5px; margin-top:10px; padding-top:10px; padding-left:8px;\n  border-top:1px dashed var(--line-2); font-size:12.5px;\n}\n.xrow{display:flex; flex-wrap:wrap; align-items:baseline; gap:5px}\n.xlab{\n  font-family:var(--mono); font-size:9.5px; letter-spacing:.1em; text-transform:uppercase;\n  color:var(--ink-3); flex:0 0 auto; padding-top:1px;\n}\n.xw{\n  padding:1.5px 7px; border-radius:6px; font-size:12px; font-weight:600;\n  background:var(--paper-2); border:1px solid var(--line); color:var(--ink-2); cursor:help;\n}\n.xrow.trap .xlab{color:var(--warn)}\n.xrow.trap .xw{background:var(--warn-soft); border-color:color-mix(in srgb,var(--warn) 30%,transparent); color:var(--warn)}\n.xrow.root .xlab{color:var(--plum)}\n.rootchip{\n  display:inline-flex; align-items:baseline; gap:6px; padding:1.5px 8px; border-radius:6px;\n  background:color-mix(in srgb,var(--plum) 11%, var(--card)); color:var(--plum);\n  border:1px solid color-mix(in srgb,var(--plum) 30%,transparent); font-size:12px;\n}\n.rootchip b{font-family:var(--mono); font-weight:500}\n.xrow.suf .xlab{color:var(--good)}\n.sufchip{\n  display:inline-flex; align-items:baseline; gap:6px; padding:1.5px 8px; border-radius:6px;\n  background:color-mix(in srgb,var(--good) 11%, var(--card)); color:var(--good);\n  border:1px solid color-mix(in srgb,var(--good) 30%,transparent); font-size:12px;\n}\n.sufchip b{font-family:var(--mono); font-weight:500}\n.sufchip span{color:var(--ink-2); font-size:11.5px}\n.xrow.opp .xlab{color:var(--plum)}\n.oppchip{\n  display:inline-flex; align-items:baseline; gap:6px; padding:1.5px 8px; border-radius:6px;\n  background:color-mix(in srgb,var(--plum) 11%, var(--card)); color:var(--plum);\n  border:1px solid color-mix(in srgb,var(--plum) 30%,transparent); font-size:12px; font-weight:600;\n}\n.opgroup{margin-bottom:22px}\n.opgroup h3{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n  font-size:19px; margin:0 0 9px;\n}\n.oplist{display:grid; gap:8px}\n.oprow{\n  display:grid; grid-template-columns:1fr auto 1fr; gap:12px; align-items:center;\n  background:var(--card); border:1px solid var(--line); border-radius:var(--r); padding:11px 14px;\n}\n.opside b{\n  display:block; font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n  font-size:18px; font-weight:600; line-height:1.15;\n}\n.opside span{display:block; font-size:12.5px; color:var(--ink-2); line-height:1.35; margin-top:2px}\n.opside.a b{color:var(--accent)}\n.opside.b{text-align:right}\n.opside.b b{color:var(--plum)}\n.opvs{\n  font-family:var(--mono); font-size:10px; letter-spacing:.12em; text-transform:uppercase;\n  color:var(--ink-3); padding:3px 8px; border-radius:999px; background:var(--paper-2);\n}\n.rootchip span{color:var(--ink-2); font-size:11.5px}\n.exmore{display:grid; gap:6px; margin-top:6px}\n.exmore .ex{margin:0}\n.exlab{\n  font-family:var(--mono); font-size:9.5px; letter-spacing:.1em; text-transform:uppercase;\n  color:var(--ink-3); margin-top:9px; padding-left:8px;\n}\n.trapbox{\n  margin-top:10px; padding:9px 11px; border-radius:9px;\n  background:var(--warn-soft); border:1px solid color-mix(in srgb,var(--warn) 26%,transparent);\n  font-size:12.5px; line-height:1.5; color:var(--ink-2);\n}\n.trapbox b{\n  display:block; font-family:var(--mono); font-size:9.5px; letter-spacing:.1em;\n  text-transform:uppercase; color:var(--warn); margin-bottom:3px;\n}\n.trapbox i{font-style:normal; color:var(--ink); font-weight:600}\n.morebtn{\n  border:0; background:transparent; font:inherit; font-size:11.5px; font-weight:600;\n  color:var(--accent); cursor:pointer; padding:4px 0 0 8px; text-align:left;\n}\n.morebtn:hover{text-decoration:underline}\n.cfoot{display:flex; align-items:center; gap:8px; margin-top:11px; padding-left:8px}\n.vtag{\n  font-size:11px; font-weight:600; color:var(--vibe-fg);\n  display:inline-flex; align-items:center; gap:4px;\n}\n.star{\n  margin-left:auto; border:1px solid var(--line-2); background:transparent; cursor:pointer;\n  font:inherit; font-size:11.5px; font-weight:600; color:var(--ink-3);\n  padding:4px 10px; border-radius:999px; transition:all .15s ease;\n}\n.star:hover{border-color:var(--good); color:var(--good)}\n.card.known .star{background:var(--good); border-color:var(--good); color:#fff}\n@media (prefers-color-scheme:dark){:host(:not([data-theme=\"light\"])) .card.known .star{color:#0d2019}}\n:host([data-theme=\"dark\"]) .card.known .star{color:#0d2019}\n\n/* ---------------------------------------------------------- connect box */\n.connect{margin-top:10px; padding-top:10px; border-top:1px dashed var(--line-2)}\n.cbtn{\n  border:0; background:transparent; font:inherit; font-size:11.5px; font-weight:600;\n  color:var(--accent); cursor:pointer; padding:0 0 0 8px; text-align:left;\n  display:inline-flex; align-items:center; gap:5px;\n}\n.cbtn:hover{text-decoration:underline}\n.cbtn.has::after{content:\"\\2022\"; color:var(--good); font-size:16px; line-height:1}\n.cpanel{display:grid; gap:7px; margin-top:9px; padding-left:8px}\n.clab{font-family:var(--mono); font-size:9.5px; letter-spacing:.1em; text-transform:uppercase; color:var(--ink-3)}\n.cin{\n  font:inherit; font-size:13.5px; width:100%; padding:8px 11px; border-radius:9px;\n  border:1px solid var(--line-2); background:var(--card-2); color:var(--ink); outline:0;\n}\n.cin:focus{border-color:var(--accent)}\n.cin::placeholder{color:var(--ink-3)}\ntextarea.cin{resize:vertical; min-height:54px; line-height:1.45; font-size:13px; font-family:var(--body)}\n.crow{display:flex; gap:6px}\n.crow .cin{flex:1 1 auto; min-width:0}\n.cgo{\n  flex:0 0 auto; border:1px solid var(--accent); background:var(--accent); color:#fff;\n  font:inherit; font-size:12.5px; font-weight:700; padding:0 14px; border-radius:9px; cursor:pointer;\n}\n.cgo:hover{background:var(--accent-deep); border-color:var(--accent-deep)}\n.crel{\n  border-radius:10px; padding:10px 12px; font-size:12.5px; line-height:1.5;\n  background:var(--paper-2); border:1px solid var(--line); color:var(--ink-2);\n}\n.crel.hit{background:var(--good-soft); border-color:color-mix(in srgb,var(--good) 32%,transparent)}\n.crel.miss{background:var(--warn-soft); border-color:color-mix(in srgb,var(--warn) 30%,transparent)}\n.cpair{display:grid; gap:5px; margin:0 0 8px}\n.cpair div{display:flex; gap:7px; align-items:baseline; flex-wrap:wrap}\n.cpair b{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n  font-size:16px; font-weight:600; color:var(--ink);\n}\n.cpair span{color:var(--ink-2); font-size:12.5px}\n.ctags{display:flex; flex-wrap:wrap; gap:5px; margin:0 0 7px}\n.ctag{\n  font-size:11px; font-weight:600; padding:2px 8px; border-radius:999px;\n  background:var(--card); border:1px solid var(--line-2); color:var(--ink-2);\n}\n.ctag.key{background:var(--accent-soft); border-color:var(--accent); color:var(--accent-deep)}\n.csaved{font-size:11px; color:var(--good); font-weight:600; justify-self:start}\n.notecard{\n  background:var(--card); border:1px solid var(--line); border-left:4px solid var(--accent);\n  border-radius:0 var(--r) var(--r) 0; padding:13px 15px; margin-bottom:10px;\n}\n.notecard h4{\n  margin:0 0 3px; font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n  font-size:19px; font-weight:600;\n}\n.notecard .nd{margin:0 0 7px; font-size:13px; color:var(--ink-2)}\n.notecard .nc{margin:0 0 5px; font-size:12.5px; color:var(--plum); font-weight:600}\n.notecard .nn{margin:0; font-size:13.5px; white-space:pre-wrap; color:var(--ink)}\n\n/* ---------------------------------------------------------- flashcards */\n.deck{max-width:600px; display:grid; gap:16px}\n.flip{perspective:1400px; height:330px; cursor:pointer}\n.flipinner{\n  position:relative; width:100%; height:100%; transition:transform .55s cubic-bezier(.4,.1,.2,1);\n  transform-style:preserve-3d;\n}\n.flip.on .flipinner{transform:rotateY(180deg)}\n.face{\n  position:absolute; inset:0; backface-visibility:hidden; -webkit-backface-visibility:hidden;\n  border-radius:20px; border:1px solid var(--line); background:var(--card);\n  box-shadow:var(--shadow-lift); padding:30px; display:flex; flex-direction:column;\n  justify-content:center; align-items:center; text-align:center; gap:12px; overflow:auto;\n}\n.face.back{transform:rotateY(180deg); background:var(--card-2); align-items:flex-start; text-align:left; justify-content:center}\n.face .big{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 144;\n  font-size:clamp(34px,7vw,52px); font-weight:600; line-height:1.02; letter-spacing:-.02em;\n  text-wrap:balance;\n}\n.face .hint{font-family:var(--mono); font-size:11px; letter-spacing:.14em; text-transform:uppercase; color:var(--ink-3)}\n.face.back .bdef{font-size:19px; font-weight:600; line-height:1.35; text-wrap:balance}\n.face.back .bword{font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40; font-size:22px; font-weight:600; color:var(--accent)}\n.deckbar{display:flex; gap:8px; align-items:center; justify-content:center; flex-wrap:wrap}\n.counter{font-family:var(--mono); font-size:12px; color:var(--ink-3); font-variant-numeric:tabular-nums}\n.progline{height:5px; background:var(--paper-2); border-radius:99px; overflow:hidden; border:1px solid var(--line)}\n.progline i{display:block; height:100%; background:var(--accent); transition:width .3s ease}\n\n/* ---------------------------------------------------------- quiz */\n.quiz{max-width:680px; display:grid; gap:14px}\n.qcard{background:var(--card); border:1px solid var(--line); border-radius:var(--r); padding:22px 22px 20px; box-shadow:var(--shadow)}\n.qsent{font-size:19px; line-height:1.6; text-wrap:pretty}\n.qsent .blank{\n  display:inline-block; min-width:92px; border-bottom:2.5px dashed var(--accent);\n  margin:0 3px; text-align:center; font-weight:700; color:var(--accent);\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n}\n.opts{display:grid; gap:8px; margin-top:18px}\n.opt{\n  text-align:left; border:1px solid var(--line-2); background:var(--card); color:var(--ink);\n  font:inherit; font-size:15px; padding:11px 14px; border-radius:11px; cursor:pointer;\n  display:flex; align-items:baseline; gap:10px; transition:all .14s ease;\n}\n.opt:hover:not(:disabled){border-color:var(--accent); background:var(--accent-soft)}\n.opt b{font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 30; font-size:17px; font-weight:600}\n.opt small{color:var(--ink-3); font-size:12.5px}\n.opt:disabled{cursor:default; opacity:.72}\n.opt.right{background:var(--good-soft); border-color:var(--good); opacity:1}\n.opt.right small{color:var(--good)}\n.opt.wrong{background:var(--warn-soft); border-color:var(--warn); opacity:1}\n.qmode{display:flex; gap:4px; background:var(--paper-2); padding:3px; border-radius:9px; border:1px solid var(--line)}\n.qmode button{\n  border:0; background:transparent; font:inherit; font-size:12px; font-weight:600;\n  color:var(--ink-2); padding:5px 11px; border-radius:7px; cursor:pointer;\n}\n.qmode button[aria-pressed=\"true\"]{background:var(--card); color:var(--accent); box-shadow:var(--shadow)}\n.typerow{display:flex; gap:8px; margin-top:18px; flex-wrap:wrap}\n.typerow input{\n  flex:1 1 220px; min-width:0; font:inherit; font-size:17px; font-weight:600;\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n  padding:11px 14px; border-radius:11px; border:1.5px solid var(--line-2);\n  background:var(--card); color:var(--ink); outline:0;\n}\n.typerow input:focus{border-color:var(--accent)}\n.typerow input::placeholder{font-family:var(--body); font-size:14px; font-weight:400; color:var(--ink-3)}\n.typerow input.right{border-color:var(--good); background:var(--good-soft)}\n.typerow input.wrong{border-color:var(--warn); background:var(--warn-soft)}\n.hintline{\n  margin-top:10px; font-size:13px; color:var(--ink-3);\n  display:flex; gap:8px; align-items:baseline; flex-wrap:wrap;\n}\n.hintline b{font-family:var(--mono); font-size:10px; letter-spacing:.1em; text-transform:uppercase; color:var(--ink-3)}\n.hintline u{text-decoration:none; font-family:var(--mono); letter-spacing:.22em; font-size:15px; color:var(--accent)}\n.feedback{padding:12px 14px; border-radius:11px; font-size:14px; line-height:1.5}\n.feedback.right{background:var(--good-soft); color:var(--good)}\n.feedback.wrong{background:var(--warn-soft); color:var(--warn)}\n.feedback b{font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1; font-size:16px}\n.score{display:flex; gap:8px; align-items:center; justify-content:space-between; flex-wrap:wrap}\n\n/* ---------------------------------------------------------- match */\n.matchgrid{display:grid; grid-template-columns:minmax(140px,1fr) minmax(230px,1.5fr); gap:10px; max-width:780px}\n.mcol{display:grid; gap:8px; align-content:start}\n.mitem{\n  border:1px solid var(--line-2); background:var(--card); color:var(--ink); font:inherit;\n  text-align:left; padding:11px 13px; border-radius:11px; cursor:pointer; font-size:14px;\n  transition:all .14s ease; line-height:1.4;\n}\n.mitem:hover:not(:disabled){border-color:var(--accent)}\n.mitem.sel{border-color:var(--accent); background:var(--accent-soft); box-shadow:var(--shadow)}\n.mitem.done{background:var(--good-soft); border-color:color-mix(in srgb,var(--good) 40%,transparent); color:var(--ink-2); cursor:default}\n.mitem.bad{animation:shake .34s}\n.mitem b{font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 30; font-size:17px; font-weight:600}\n@keyframes shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-6px)}75%{transform:translateX(6px)}}\n@media (prefers-reduced-motion:reduce){\n  *{animation-duration:.01ms !important; transition-duration:.01ms !important}\n  .flipinner{transition:none}\n}\n\n/* ---------------------------------------------------------- roots */\n.rootgrid{display:grid; grid-template-columns:repeat(auto-fill,minmax(330px,1fr)); gap:16px}\n.flowercard{background:var(--card); border:1px solid var(--line); border-radius:var(--r); padding:16px 16px 14px; box-shadow:var(--shadow)}\n.flower{position:relative; height:276px; margin:2px 0 6px}\n.flower svg{position:absolute; inset:0; width:100%; height:100%; overflow:visible}\n.petal{\n  position:absolute; transform:translate(-50%,-50%); background:var(--card-2);\n  border:1px solid var(--line-2); border-radius:999px; padding:3.5px 9px;\n  font-size:11.5px; font-weight:600; white-space:nowrap; color:var(--ink);\n  box-shadow:var(--shadow); max-width:106px; overflow:hidden; text-overflow:ellipsis;\n}\n.core{\n  position:absolute; left:50%; top:50%; transform:translate(-50%,-50%);\n  width:110px; height:110px; border-radius:50%; background:var(--accent-soft);\n  border:2px solid var(--accent); display:flex; flex-direction:column;\n  align-items:center; justify-content:center; text-align:center; gap:2px; padding:10px;\n}\n.core .rt{font-family:var(--mono); font-size:12.5px; font-weight:500; color:var(--accent-deep); line-height:1.15}\n.core .rm{font-size:10.5px; color:var(--ink-2); line-height:1.25}\n.bonus{font-size:12px; color:var(--ink-3); border-top:1px solid var(--line); padding-top:9px; margin-top:4px}\n.bonus b{color:var(--ink-2); font-weight:600}\n\n/* ---------------------------------------------------------- misc */\n.section-h{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 60;\n  font-size:26px; font-weight:600; margin:0 0 4px; letter-spacing:-.01em;\n}\n.section-p{margin:0 0 18px; color:var(--ink-2); max-width:64ch; font-size:14.5px}\n.empty{padding:44px 20px; text-align:center; color:var(--ink-3); font-size:15px}\n.vgroup{margin-bottom:22px}\n.vgroup h3{\n  font-family:var(--display); font-variation-settings:\"SOFT\" 100,\"WONK\" 1,\"opsz\" 40;\n  font-size:19px; margin:0 0 2px; display:flex; align-items:baseline; gap:8px;\n}\n.vgroup p{margin:0 0 9px; font-size:13px; color:var(--ink-3)}\n.wordchips{display:flex; flex-wrap:wrap; gap:5px}\n.wc{\n  font-size:12.5px; padding:3px 9px; border-radius:7px; background:var(--card);\n  border:1px solid var(--line); color:var(--ink-2); cursor:help;\n}\n.wc:hover{border-color:var(--accent); color:var(--accent)}\n.note{\n  background:var(--card-2); border:1px solid var(--line-2); border-left:4px solid var(--accent);\n  border-radius:0 var(--r) var(--r) 0; padding:13px 16px; margin:0 0 20px;\n  font-size:13.5px; color:var(--ink-2); line-height:1.55;\n}\n.note b{color:var(--ink)}\nfooter{margin-top:40px; padding-top:18px; border-top:1px solid var(--line); font-size:12.5px; color:var(--ink-3); display:flex; flex-wrap:wrap; gap:12px; justify-content:space-between}\n@media (max-width:600px){\n  .masthead{padding:26px 0 18px}\n  .matchgrid{grid-template-columns:1fr}\n  .flip{height:290px}\n}\n\n/* ---------------------------------------------------------- narrow screens */\n:host{max-width:100%}\n@media (max-width:560px){\n  .modes{flex-wrap:wrap; width:100%}\n  .mode{flex:1 1 auto; padding:7px 9px}\n  .field{min-width:0; flex:1 1 100%}\n  .toolbar{gap:8px}\n  .wrap{padding-left:14px; padding-right:14px}\n}\n";
  var HTML = "<div class=\"wrap\">\n  <header class=\"masthead\">\n    <p class=\"eyebrow\">Cute Calculus &middot; SAT Prep</p>\n    <h1>Pretty <em>Smart</em></h1>\n    <p class=\"dek\">The 1000 most common SAT words, sorted into ten sets of exactly one hundred. Every word comes with its real definition, a sentence you can actually picture, a color for what it <em>feels</em> like, and the lookalike word it is most often mistaken for. The three hundred hardest words get three sentences instead of one. Then flashcards, quizzes, and a matching game that will not let you guess your way through.</p>\n    <div class=\"statrow\">\n      <div class=\"stat\"><b>1000</b><span>words</span></div>\n      <div class=\"stat\"><b>10</b><span>sets of 100</span></div>\n      <div class=\"stat\"><b>42</b><span>root families</span></div>\n      <div class=\"stat\"><b>157</b><span>words that fool you</span></div>\n      <div class=\"stat\"><b>462</b><span>endings decoded</span></div>\n      <div class=\"stat\"><b>31</b><span>opposite pairs</span></div>\n      <div class=\"stat live\"><b id=\"knownCount\">0</b><span>marked as known</span></div>\n      <div class=\"stat live warn\"><b id=\"weakCount\">0</b><span>words to fix</span></div>\n    </div>\n  </header>\n\n  <nav class=\"spine\" id=\"spine\" aria-label=\"Study sets\"></nav>\n\n  <div class=\"toolbar\">\n    <div class=\"modes\" id=\"modes\" role=\"group\" aria-label=\"Study mode\">\n      <button class=\"mode\" data-mode=\"study\" aria-pressed=\"true\">Study</button>\n      <button class=\"mode\" data-mode=\"cards\" aria-pressed=\"false\">Flashcards</button>\n      <button class=\"mode\" data-mode=\"quiz\" aria-pressed=\"false\">Fill in the Blank</button>\n      <button class=\"mode\" data-mode=\"match\" aria-pressed=\"false\">Match</button>\n      <button class=\"mode\" data-mode=\"drill\" aria-pressed=\"false\">Speed Drill</button>\n    </div>\n    <div class=\"grow\"></div>\n    <div class=\"field\" id=\"searchField\">\n      <svg width=\"14\" height=\"14\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\"><circle cx=\"7\" cy=\"7\" r=\"4.5\"/><path d=\"M10.5 10.5 14 14\"/></svg>\n      <input id=\"search\" type=\"search\" placeholder=\"Find a word or meaning\" aria-label=\"Search words\">\n    </div>\n    <button class=\"btn\" id=\"themeBtn\" title=\"Switch theme\">Theme</button>\n  </div>\n\n  <div class=\"vibebar\" id=\"vibebar\"></div>\n  <main id=\"stage\"></main>\n\n  <footer>\n    <span>Pretty Smart, by Cute Calculus. The 1000 most common SAT vocabulary words.</span>\n    <span>Your stars and progress save in this browser only.</span>\n  </footer>\n</div>";

  /* Mount into `hostEl`. Safe to call twice on the same element. */
  window.PrettySmartVocabApp = function (hostEl) {
    if (!hostEl || hostEl.getAttribute('data-psv-ready') === '1') return;
    if (!hostEl.attachShadow) {          /* no shadow DOM, no app */
      hostEl.textContent = 'This browser is too old to run the vocabulary practice.';
      return;
    }
    hostEl.setAttribute('data-psv-ready', '1');

    var shadow = hostEl.shadowRoot || hostEl.attachShadow({ mode: 'open' });
    shadow.innerHTML = '<style>' + CSS + '</style>' + HTML;

    var realDoc = window.document;

    /* Everything below this line is the artifact's own code, unchanged apart
       from where its data comes from. It thinks it is talking to `document`;
       this shim quietly points it at the shadow root instead. Lookups go to
       the shadow root, element creation goes to the real document (a node made
       by the shadow root would belong to nothing), and documentElement is the
       host, so the app's Theme button still toggles the right element. */
    var document = {
      getElementById: function (id) {
        return shadow.querySelector('#' + id.replace(/([^\w-])/g, '\\$1'));
      },
      querySelector:    function (s) { return shadow.querySelector(s); },
      querySelectorAll: function (s) { return shadow.querySelectorAll(s); },
      createElement:    function (t) { return realDoc.createElement(t); },
      createElementNS:  function (n, t) { return realDoc.createElementNS(n, t); },
      createTextNode:   function (t) { return realDoc.createTextNode(t); },
      addEventListener: function () { return realDoc.addEventListener.apply(realDoc, arguments); },
      documentElement:  hostEl,
      body:             shadow
    };


    (function(){
    "use strict";
    var D = window.PSV_DATA;
    var SETS = D.sets, FAMS = D.families, VIBES = D.vibes;
    var ALL = []; SETS.forEach(function(s){ s.words.forEach(function(w){ w.set = s.n; ALL.push(w); }); });
    var BY = {}; ALL.forEach(function(w){ BY[w.w] = w; });

    var POSNAME = {n:"noun", v:"verb", adj:"adjective", adv:"adverb", prep:"preposition", conj:"conjunction"};
    var POLNAME = {pos:"good vibe", neg:"bad vibe", mid:"neutral"};

    /* ---------------------------------------------------- persistence */
    var KEY = "pretty-smart-vocab-v1";
    var state = {known:{}, miss:{}, best:0, set:1, mode:"study", vibe:null, qstyle:"choices", notes:{}};
    try{ var raw = localStorage.getItem(KEY); if(raw){ var p = JSON.parse(raw); if(p && p.known) state.known = p.known; if(p && p.miss) state.miss = p.miss; if(p && p.best) state.best = p.best; if(p && p.set) state.set = p.set; if(p && p.qstyle) state.qstyle = p.qstyle; if(p && p.notes) state.notes = p.notes; } }catch(e){}
    function save(){ try{ localStorage.setItem(KEY, JSON.stringify({known:state.known, miss:state.miss, best:state.best, set:state.set, qstyle:state.qstyle, notes:state.notes})); }catch(e){} }

    /* ---------------------------------------------------- helpers */
    function el(tag, cls, txt){ var n = document.createElement(tag); if(cls) n.className = cls; if(txt != null) n.textContent = txt; return n; }
    function vibeOf(k){ return VIBES[k] || VIBES.neutral; }
    function shuffle(a){ a = a.slice(); for(var i=a.length-1;i>0;i--){ var j = Math.floor(Math.random()*(i+1)); var t=a[i]; a[i]=a[j]; a[j]=t; } return a; }
    function pick(a, n){ return shuffle(a).slice(0, n); }
    function curSet(){ return SETS[state.set-1]; }
    function knownCount(){ var c=0; for(var k in state.known){ if(state.known[k]) c++; } return c; }
    function weakList(){
      var out = [];
      for(var k in state.miss){ if(state.miss[k] > 0 && BY[k]) out.push(BY[k]); }
      out.sort(function(a,b){ return (state.miss[b.w]-state.miss[a.w]) || (a.w < b.w ? -1 : 1); });
      return out;
    }
    function markRight(w){ state.known[w] = true; if(state.miss[w]) delete state.miss[w]; save(); refreshCount(); }
    function markWrong(w){ state.miss[w] = (state.miss[w]||0) + 1; delete state.known[w]; save(); refreshCount(); }
    function refreshCount(){
      document.getElementById("knownCount").textContent = knownCount();
      document.getElementById("weakCount").textContent = weakList().length;
    }

    /* Example sentence with the target word highlighted. */
    function exampleNode(w){
      var box = el("p","ex");
      if(w.f){
        var i = w.e.toLowerCase().indexOf(w.f.toLowerCase());
        if(i > -1){
          box.appendChild(document.createTextNode(w.e.slice(0,i)));
          box.appendChild(el("mark", null, w.e.substr(i, w.f.length)));
          box.appendChild(document.createTextNode(w.e.slice(i + w.f.length)));
          return box;
        }
      }
      box.textContent = w.e;
      return box;
    }

    /* ---------------------------------------------------- set spine */
    function buildSpine(){
      var spine = document.getElementById("spine");
      spine.textContent = "";
      SETS.forEach(function(s){
        var b = el("button","tab");
        b.style.setProperty("--tabc", tabColor(s.n));
        b.setAttribute("aria-pressed", String(s.n === state.set && ["roots","vibes","weak","opp","notes"].indexOf(state.mode) === -1));
        var t = el("b","", "Set " + s.n);
        var r = el("i","", s.from + " – " + s.to);
        var got = 0;
        s.words.forEach(function(w){ if(state.known[w.w]) got++; });
        var bar = el("span","bar"); var fillb = el("i");
        fillb.style.width = (got / s.words.length * 100) + "%";
        bar.appendChild(fillb);
        b.title = got + " of " + s.words.length + " marked as known";
        b.appendChild(t); b.appendChild(r); b.appendChild(bar);
        b.onclick = function(){ state.set = s.n; if(["roots","vibes","weak","opp","notes"].indexOf(state.mode) > -1) state.mode="study"; stopDrill(); save(); render(); };
        spine.appendChild(b);
      });
      var ob = el("button","tab wide");
      ob.style.setProperty("--tabc","var(--plum)");
      ob.setAttribute("aria-pressed", String(state.mode === "opp"));
      ob.appendChild(el("b","", "Opposite Pairs"));
      ob.appendChild(el("i","", (D.opposites||[]).reduce(function(n,g){return n+g.p.length;},0) + " matched pairs"));
      ob.onclick = function(){ stopDrill(); state.mode = "opp"; render(); };
      spine.appendChild(ob);

      var weakN = weakList().length;
      var wb = el("button","tab wide");
      wb.style.setProperty("--tabc","var(--warn)");
      wb.setAttribute("aria-pressed", String(state.mode === "weak"));
      wb.appendChild(el("b","", "Words to Fix"));
      wb.appendChild(el("i","", weakN ? weakN + " you have missed" : "nothing missed yet"));
      wb.onclick = function(){ stopDrill(); state.mode = "weak"; render(); };
      spine.appendChild(wb);

      var noteN = noteWords().length;
      var nb = el("button","tab wide");
      nb.style.setProperty("--tabc","var(--good)");
      nb.setAttribute("aria-pressed", String(state.mode === "notes"));
      nb.appendChild(el("b","", "My Notes"));
      nb.appendChild(el("i","", noteN ? noteN + " word" + (noteN === 1 ? "" : "s") : "nothing written yet"));
      nb.onclick = function(){ stopDrill(); state.mode = "notes"; render(); };
      spine.appendChild(nb);

      ["roots","vibes"].forEach(function(m){
        var b = el("button","tab wide");
        b.style.setProperty("--tabc", m === "roots" ? "var(--plum)" : "var(--accent)");
        b.setAttribute("aria-pressed", String(state.mode === m));
        b.appendChild(el("b","", m === "roots" ? "Root Flowers" : "The Vibe Index"));
        b.appendChild(el("i","", m === "roots" ? "42 word families" : "20 feelings"));
        b.onclick = function(){ stopDrill(); state.mode = m; render(); };
        spine.appendChild(b);
      });
    }
    var TABC = ["#d92b63","#c26a2e","#b5842f","#4f9a86","#2f8f9d","#3f6fa8","#5a5aa0","#7b4b8a","#a8477a","#c0392b"];
    function tabColor(n){ return TABC[(n-1) % TABC.length]; }

    /* ---------------------------------------------------- vibe bar */
    function buildVibeBar(){
      var bar = document.getElementById("vibebar");
      bar.textContent = "";
      if(["roots","vibes","weak","opp","notes"].indexOf(state.mode) > -1){ bar.style.display = "none"; return; }
      bar.style.display = "flex";
      var counts = {};
      curSet().words.forEach(function(w){ counts[w.v] = (counts[w.v]||0) + 1; });
      var keys = Object.keys(counts).sort(function(a,b){ return counts[b]-counts[a]; });

      var all = el("button","vchip");
      all.style.setProperty("--vibe","var(--ink-2)");
      all.setAttribute("aria-pressed", String(state.vibe === null));
      all.appendChild(document.createTextNode("All 100"));
      all.onclick = function(){ state.vibe = null; render(); };
      bar.appendChild(all);

      keys.forEach(function(k){
        var v = vibeOf(k);
        var c = el("button","vchip");
        c.style.setProperty("--vibe", v.c);
        c.setAttribute("aria-pressed", String(state.vibe === k));
        c.appendChild(document.createTextNode(v.e + " " + v.t));
        c.appendChild(el("u","", String(counts[k])));
        c.onclick = function(){ state.vibe = (state.vibe === k ? null : k); render(); };
        bar.appendChild(c);
      });
    }

    /* ---------------------------------------------------- filtering */
    function visibleWords(){
      var q = (document.getElementById("search").value || "").trim().toLowerCase();
      var list = curSet().words;
      if(q){ list = ALL; }
      return list.filter(function(w){
        if(state.vibe && w.v !== state.vibe) return false;
        if(!q) return true;
        return w.w.indexOf(q) > -1 || w.d.toLowerCase().indexOf(q) > -1 || (w.d2 && w.d2.toLowerCase().indexOf(q) > -1);
      });
    }

    /* ---------------------------------------------------- study mode */
    function renderStudy(stage){
      var words = visibleWords();
      var q = document.getElementById("search").value.trim();
      var h = el("h2","section-h", q ? "Searching all 1000 words" : "Set " + state.set + ": " + curSet().from + " to " + curSet().to);
      var p = el("p","section-p");
      p.textContent = q
        ? words.length + " word" + (words.length===1?"":"s") + " match “" + q + "”."
        : "Tap the mint button on a card once the word has stuck. The stripe down the left side is the word’s vibe, and the little tag on the right tells you whether it is a compliment, an insult, or neither. That charge alone answers a surprising number of test questions. Under the dashed line sits the word\u2019s root, its ending and what that ending tells you about part of speech, the words that mean roughly the same thing, its opposite where it has a clean one, and the lookalike it is most often mistaken for. An amber Careful box means the word does not mean what it sounds like.";
      stage.appendChild(h); stage.appendChild(p);

      if(!words.length){ stage.appendChild(el("p","empty","Nothing here. Try a different search or vibe.")); return; }

      var grid = el("div","cards");
      words.forEach(function(w){ grid.appendChild(wordCard(w)); });
      stage.appendChild(grid);
    }

    /* ---------------------------------------------------- connections
       Everything here runs offline against the 1000 words already in the page.
       The student types a word they were reminded of; we find it, put the two
       definitions side by side, and name whatever actually links them. */
    var STOP = {};
    ("a an the to to's of or and is are was were be been being am in on at for with without from into by as it its this that these those "
    + "not no very usually especially something someone somebody thing things person people way ways do does did done make makes made "
    + "cause causes caused give gives given take takes taken so but if because than then there their they them he she his her him you your "
    + "i me my we our us who whom which what when where why how can could would should will shall may might must about like similar same "
    + "different word words mean means meaning remind reminds reminded think thinks thought sounds sound looks look also both too more most "
    + "less least other another any some all each every kind sort type quality state act one two out up down over under again").split(" ")
      .forEach(function(s){ if(s) STOP[s] = 1; });

    /* endings that are not evidence of a shared word family */
    var SUFFIXES = {ation:1,ition:1,ution:1,tion:1,sion:1,ment:1,ness:1,ance:1,ence:1,able:1,ible:1,ical:1,ious:1,eous:1,uous:1,
                    ing:1,ity:1,ate:1,ive:1,ous:1,ary:1,ual:1,ial:1,ize:1,ise:1,ent:1,ant:1,ful:1,less:1,ist:1,ism:1,ally:1};

    function tokens(s){ return String(s || "").toLowerCase().match(/[a-z]{2,}/g) || []; }

    /* longest common substring, used to spot a shared base like abase / debase */
    function lcs(a, b){
      var best = "", i, j, prev = [], cur;
      for(j = 0; j <= b.length; j++) prev[j] = 0;
      for(i = 1; i <= a.length; i++){
        cur = [0];
        for(j = 1; j <= b.length; j++){
          if(a.charAt(i-1) === b.charAt(j-1)){
            cur[j] = prev[j-1] + 1;
            if(cur[j] > best.length) best = a.slice(i - cur[j], i);
          } else { cur[j] = 0; }
        }
        prev = cur;
      }
      return best;
    }

    function sharedStem(a, b){
      var s = lcs(a, b);
      if(s.length < 4) return null;
      if(SUFFIXES[s]) return null;
      if(s.length < 0.5 * Math.min(a.length, b.length)) return null;
      return s;
    }

    function editDistance(a, b){
      if(Math.abs(a.length - b.length) > 2) return 9;
      var m = a.length, n = b.length, i, j, prev = [], cur = [];
      for(j = 0; j <= n; j++) prev[j] = j;
      for(i = 1; i <= m; i++){
        cur = [i];
        for(j = 1; j <= n; j++){
          cur[j] = Math.min(prev[j] + 1, cur[j-1] + 1, prev[j-1] + (a.charAt(i-1) === b.charAt(j-1) ? 0 : 1));
        }
        prev = cur;
      }
      return prev[n];
    }

    /* Which of the 1000 is the student pointing at? Accepts a whole sentence. */
    function findTarget(text, self){
      var t = tokens(text), i, k;
      for(i = 0; i < t.length; i++){ if(t[i] !== self && BY[t[i]]) return {w: BY[t[i]], exact: true}; }
      var best = null, bestD = 3;
      for(i = 0; i < t.length; i++){
        if(t[i].length < 4 || STOP[t[i]] || t[i] === self) continue;
        for(k = 0; k < ALL.length; k++){
          if(ALL[k].w === self) continue;
          var d = editDistance(t[i], ALL[k].w);
          if(d < bestD){ bestD = d; best = {w: ALL[k], exact: false, typed: t[i]}; }
        }
      }
      return best;
    }

    function meaningOverlap(a, b){
      var A = {}, out = [];
      tokens(a.d + " " + (a.d2 || "")).forEach(function(t){ if(!STOP[t] && t.length > 3) A[t] = 1; });
      tokens(b.d + " " + (b.d2 || "")).forEach(function(t){
        if(!STOP[t] && t.length > 3 && A[t] && out.indexOf(t) < 0) out.push(t);
      });
      return out;
    }

    function relate(a, b){
      var out = [];
      function has(list, w){ return !!(list && list.indexOf(w) > -1); }
      if(has(a.conf, b.w) || has(b.conf, a.w))
        out.push({k:1, t:"Listed lookalikes", d:"These two are on the mix-up list. Learn them as a pair or you will lose a point to it."});
      if(a.root && b.root && a.root[0] === b.root[0])
        out.push({k:1, t:"Same root: " + a.root[0], d:"That root means " + a.root[1] + ". Same family, so the meanings lean the same way."});
      if(a.opp === b.w || b.opp === a.w)
        out.push({k:1, t:"Opposites", d:"One is the clean opposite of the other. Learn them together, they are worth double."});
      if(has(a.syn, b.w) || has(b.syn, a.w))
        out.push({k:1, t:"Near synonyms", d:"Close enough in meaning to swap into the same sentence."});
      var st = sharedStem(a.w, b.w);
      if(st)
        out.push({k:1, t:"Same core word: " + st, d:"Same base, different prefix or ending. That is almost always a real family, not a coincidence."});
      var ov = meaningOverlap(a, b);
      if(ov.length)
        out.push({k:0, t:"Definitions share: " + ov.slice(0,4).join(", "), d:"The two meanings actually touch."});
      if(a.v && a.v === b.v)
        out.push({k:0, t:"Both are " + String(vibeOf(a.v).t).toLowerCase(), d:"Same vibe, so they turn up in the same kind of sentence."});
      if(a.z === b.z && a.z !== "mid")
        out.push({k:0, t:"Both are a " + POLNAME[a.z], d:"Same charge. That alone answers a lot of tone questions."});
      return out;
    }

    function tidyNote(word){
      var r = state.notes[word];
      if(r && !(r.c && r.c.trim()) && !(r.n && r.n.trim())) delete state.notes[word];
    }

    function noteWords(){
      var out = [], k, r;
      for(k in state.notes){
        r = state.notes[k];
        if(BY[k] && r && ((r.c && r.c.trim()) || (r.n && r.n.trim()))) out.push(BY[k]);
      }
      out.sort(function(a, b){ return a.w < b.w ? -1 : 1; });
      return out;
    }

    /* The box that sits at the bottom of every word card. */
    function connectBox(w){
      var rec = state.notes[w.w] || {};
      var wrap = el("div","connect");
      var btn = el("button","cbtn");
      function filled(){ return !!((rec.c && rec.c.trim()) || (rec.n && rec.n.trim())); }
      function label(){ return filled() ? "your note" : "+ make a connection"; }
      btn.textContent = label();
      if(filled()) btn.classList.add("has");

      var body = el("div","cpanel");
      body.hidden = true;
      btn.onclick = function(){
        body.hidden = !body.hidden;
        btn.textContent = body.hidden ? label() : "− hide";
        if(!body.hidden && rec.c && rec.c.trim() && out.hidden) run(true);
      };
      wrap.appendChild(btn);

      body.appendChild(el("div","clab","This word reminds me of"));
      var row = el("div","crow");
      var inp = el("input","cin");
      inp.type = "text";
      inp.placeholder = "another word, and why";
      inp.value = rec.c || "";
      var go = el("button","cgo","Check");
      row.appendChild(inp); row.appendChild(go);
      body.appendChild(row);

      var out = el("div","crel");
      out.hidden = true;
      body.appendChild(out);

      function run(quiet){
        var text = inp.value.trim();
        rec.c = text;
        state.notes[w.w] = rec;
        tidyNote(w.w);
        if(!quiet) save();
        btn.classList.toggle("has", filled());
        if(!text){ out.hidden = true; return; }
        out.hidden = false;
        out.textContent = "";
        var found = findTarget(text, w.w);
        if(!found){
          out.className = "crel miss";
          out.appendChild(document.createTextNode("No word from the 1000 in there. Your note is saved anyway. Try typing just the single word you are thinking of."));
          return;
        }
        var b = found.w;
        out.className = "crel" + (found.exact ? " hit" : "");
        if(!found.exact){
          out.appendChild(el("div","", "“" + found.typed + "” is not one of the 1000. Closest one on the list:"));
        }
        var pair = el("div","cpair");
        [w, b].forEach(function(x){
          var r = el("div");
          r.appendChild(el("b","", x.w));
          r.appendChild(el("span","", x.d));
          pair.appendChild(r);
        });
        out.appendChild(pair);

        var links = relate(w, b);
        var tags = el("div","ctags");
        if(!links.length){
          tags.appendChild(el("span","ctag","Nothing formally links them"));
          out.appendChild(tags);
          out.appendChild(el("div","", "Both are on the list, but nothing in the data ties them together. Read the two definitions above and decide for yourself. Noticing that they are NOT related is worth writing down too."));
        } else {
          links.forEach(function(L){ tags.appendChild(el("span","ctag" + (L.k ? " key" : ""), L.t)); });
          out.appendChild(tags);
          var strong = links.filter(function(L){ return L.k; });
          (strong.length ? strong : links).slice(0, 2).forEach(function(L){
            out.appendChild(el("div","", L.d));
          });
        }
      }
      go.onclick = function(){ run(false); };
      inp.addEventListener("keydown", function(e){
        if(e.key === "Enter"){ e.preventDefault(); run(false); }
      });

      body.appendChild(el("div","clab","My note"));
      var ta = el("textarea","cin");
      ta.rows = 2;
      ta.placeholder = "a question, a trick for remembering it, where you saw it";
      ta.value = rec.n || "";
      var saved = el("span","csaved","saved");
      saved.hidden = true;
      var tt;
      ta.addEventListener("input", function(){
        rec.n = ta.value;
        state.notes[w.w] = rec;
        clearTimeout(tt);
        tt = setTimeout(function(){
          tidyNote(w.w);
          save();
          btn.classList.toggle("has", filled());
          saved.hidden = false;
          setTimeout(function(){ saved.hidden = true; }, 1200);
        }, 400);
      });
      body.appendChild(ta);
      body.appendChild(saved);

      wrap.appendChild(body);
      return wrap;
    }

    function renderNotes(stage){
      var list = noteWords();
      stage.appendChild(el("h2","section-h","My Notes"));
      stage.appendChild(el("p","section-p","Every word you have written on. This saves in this browser only, so it is yours. Nobody else can see it."));
      if(!list.length){
        stage.appendChild(el("p","empty","Nothing yet. Open any word card and tap “make a connection.”"));
        return;
      }
      var copy = el("button","btn","Copy all my notes");
      copy.onclick = function(){
        var txt = list.map(function(w){
          var r = state.notes[w.w];
          return w.w + " — " + w.d
            + (r.c && r.c.trim() ? "\n  reminds me of: " + r.c : "")
            + (r.n && r.n.trim() ? "\n  " + r.n : "");
        }).join("\n\n");
        try{
          navigator.clipboard.writeText(txt);
          copy.textContent = "copied";
          setTimeout(function(){ copy.textContent = "Copy all my notes"; }, 1500);
        }catch(e){ copy.textContent = "could not copy"; }
      };
      stage.appendChild(copy);

      var box = el("div","");
      box.style.marginTop = "16px";
      list.forEach(function(w){
        var r = state.notes[w.w];
        var card = el("div","notecard");
        card.appendChild(el("h4","", w.w));
        card.appendChild(el("p","nd", w.d));
        if(r.c && r.c.trim()) card.appendChild(el("p","nc", "reminds me of: " + r.c));
        if(r.n && r.n.trim()) card.appendChild(el("p","nn", r.n));
        box.appendChild(card);
      });
      stage.appendChild(box);
    }

    function wordCard(w){
      var v = vibeOf(w.v);
      var c = el("article","card" + (state.known[w.w] ? " known" : ""));
      c.style.setProperty("--vibe", v.c);

      var head = el("div","whead");
      head.appendChild(el("span","word", w.w));
      head.appendChild(el("span","pos", POSNAME[w.p] || w.p));
      head.appendChild(el("span","pol " + w.z, POLNAME[w.z]));
      c.appendChild(head);

      c.appendChild(el("p","def", w.d));
      if(w.d2){
        var d2 = el("p","def2");
        d2.appendChild(el("i","", "also " + (POSNAME[w.p2] || w.p2) + " · "));
        d2.appendChild(document.createTextNode(w.d2));
        c.appendChild(d2);
      }
      c.appendChild(exampleNode(w));
      if(w.trap) c.appendChild(trapNode(w));
      if(w.e2){
        var more = el("div","exmore");
        more.hidden = true;
        w.e2.forEach(function(sent){
          var p = el("p","ex", sent);
          more.appendChild(p);
        });
        var btn = el("button","morebtn","+ two more sentences");
        btn.onclick = function(){
          more.hidden = !more.hidden;
          btn.textContent = more.hidden ? "+ two more sentences" : "\u2212 hide extra sentences";
        };
        c.appendChild(btn);
        c.appendChild(more);
      }
      var xb = extrasBlock(w);
      if(xb) c.appendChild(xb);

      c.appendChild(connectBox(w));

      var f = el("div","cfoot");
      var tag = el("span","vtag", v.e + " " + v.t);
      f.appendChild(tag);
      var star = el("button","star", state.known[w.w] ? "✓ known" : "mark known");
      star.onclick = function(){
        state.known[w.w] = !state.known[w.w];
        if(!state.known[w.w]) delete state.known[w.w];
        save(); refreshCount();
        c.classList.toggle("known", !!state.known[w.w]);
        star.textContent = state.known[w.w] ? "✓ known" : "mark known";
      };
      f.appendChild(star);
      c.appendChild(f);
      return c;
    }

    /* Words that do not mean what they sound like. */
    function trapNode(w){
      var box = el("div","trapbox");
      box.appendChild(el("b","","Careful"));
      box.appendChild(document.createTextNode("Sounds like it means " + w.trap[0] + ". It actually means "));
      box.appendChild(el("i","", w.trap[1]));
      box.appendChild(document.createTextNode("."));
      return box;
    }

    /* Root, near synonyms, and the lookalike trap. */
    function extrasBlock(w){
      if(!w.root && !w.syn && !w.conf) return null;
      var box = el("div","extras");
      if(w.root){
        var r = el("div","xrow root");
        r.appendChild(el("span","xlab","Root"));
        var chip = el("span","rootchip");
        chip.appendChild(el("b","", w.root[0]));
        chip.appendChild(el("span","", w.root[1]));
        r.appendChild(chip);
        box.appendChild(r);
      }
      if(w.suf){
        var sf = el("div","xrow suf");
        sf.appendChild(el("xlab" === "" ? "span" : "span","xlab","Ending"));
        var sc = el("span","sufchip");
        sc.appendChild(el("b","", "-" + w.suf[0]));
        sc.appendChild(el("span","", "marks it as " + w.suf[1] + ", " + w.suf[2]));
        sf.appendChild(sc);
        box.appendChild(sf);
      }
      if(w.opp && BY[w.opp]){
        var op = el("div","xrow opp");
        op.appendChild(el("span","xlab","Opposite"));
        var oc = el("span","oppchip", w.opp);
        oc.title = BY[w.opp].d;
        op.appendChild(oc);
        box.appendChild(op);
      }
      if(w.syn){
        var sr = el("div","xrow");
        sr.appendChild(el("span","xlab","Same idea"));
        w.syn.forEach(function(x){
          var c = el("span","xw", x);
          if(BY[x]) c.title = BY[x].d;
          sr.appendChild(c);
        });
        box.appendChild(sr);
      }
      if(w.conf){
        var t = el("div","xrow trap");
        t.appendChild(el("span","xlab","Not"));
        w.conf.forEach(function(x){
          var c = el("span","xw", x);
          if(BY[x]) c.title = BY[x].w + ": " + BY[x].d;
          t.appendChild(c);
        });
        box.appendChild(t);
      }
      return box;
    }

    /* ---------------------------------------------------- flashcards */
    var deck = {list:[], i:0, flipped:false, setN:null, vibe:undefined};
    function renderCards(stage){
      if(deck.setN !== "weak" && (deck.setN !== state.set || deck.vibe !== state.vibe || !deck.list.length)){
        var pool = curSet().words.filter(function(w){ return !state.vibe || w.v === state.vibe; });
        deck = {list: shuffle(pool), i:0, flipped:false, setN: state.set, vibe: state.vibe};
      }
      var w = deck.list[deck.i];
      stage.appendChild(el("h2","section-h","Flashcards"));
      var sub = el("p","section-p","Say the meaning out loud before you flip. Out loud matters: it is the difference between recognizing a word and owning it.");
      stage.appendChild(sub);

      var wrap = el("div","deck");
      var v = vibeOf(w.v);

      var flip = el("div","flip" + (deck.flipped ? " on" : ""));
      flip.tabIndex = 0;
      flip.setAttribute("role","button");
      flip.setAttribute("aria-label","Flip card");
      var inner = el("div","flipinner");

      var front = el("div","face");
      front.appendChild(el("span","hint", v.e + " " + v.t));
      front.appendChild(el("div","big", w.w));
      front.appendChild(el("span","hint","tap to flip"));
      inner.appendChild(front);

      var back = el("div","face back");
      back.appendChild(el("span","bword", w.w + "  ·  " + (POSNAME[w.p] || w.p)));
      back.appendChild(el("p","bdef", w.d));
      if(w.d2) back.appendChild(el("p","def2","also: " + w.d2));
      var bex = exampleNode(w); bex.style.setProperty("--vibe", v.c); back.appendChild(bex);
      if(w.trap){ var tn = trapNode(w); tn.style.width = "100%"; back.appendChild(tn); }
      if(w.e2){ w.e2.forEach(function(sent){ var p = el("p","ex", sent); p.style.width = "100%"; back.appendChild(p); }); }
      var bx = extrasBlock(w); if(bx){ bx.style.width = "100%"; bx.style.paddingLeft = "0"; bx.style.borderTopStyle = "solid"; back.appendChild(bx); }
      inner.appendChild(back);

      flip.appendChild(inner);
      var doFlip = function(){ deck.flipped = !deck.flipped; flip.classList.toggle("on", deck.flipped); };
      flip.onclick = doFlip;
      flip.onkeydown = function(e){ if(e.key === " " || e.key === "Enter"){ e.preventDefault(); doFlip(); } };
      wrap.appendChild(flip);

      var line = el("div","progline"); var fill = el("i");
      fill.style.width = ((deck.i+1) / deck.list.length * 100) + "%";
      line.appendChild(fill); wrap.appendChild(line);

      var bar = el("div","deckbar");
      var prev = el("button","btn","← Back");
      prev.onclick = function(){ deck.i = (deck.i - 1 + deck.list.length) % deck.list.length; deck.flipped = false; render(); };
      var got = el("button","btn primary","Got it →");
      got.onclick = function(){ markRight(w.w); next(); };
      var again = el("button","btn","Study again →");
      again.onclick = function(){ markWrong(w.w); next(); };
      function next(){ deck.i = (deck.i + 1) % deck.list.length; deck.flipped = false; render(); }
      var count = el("span","counter", (deck.i+1) + " / " + deck.list.length);
      var reshuffle = el("button","btn","Reshuffle");
      reshuffle.onclick = function(){ deck.list = shuffle(deck.list); deck.i = 0; deck.flipped = false; render(); };
      bar.appendChild(prev); bar.appendChild(again); bar.appendChild(got);
      bar.appendChild(count); bar.appendChild(reshuffle);
      wrap.appendChild(bar);
      stage.appendChild(wrap);
    }

    /* ---------------------------------------------------- quiz */
    var quiz = null, quizPool = null;
    function newQuiz(){
      var pool = (quizPool || curSet().words).filter(function(w){ return w.b && (quizPool || !state.vibe || w.v === state.vibe); });
      var distractorPool = quizPool ? ALL : curSet().words;
      var qs = pick(pool, Math.min(10, pool.length)).map(function(w){
        var same = distractorPool.filter(function(x){ return x.w !== w.w && x.p === w.p; });
        if(same.length < 3) same = distractorPool.filter(function(x){ return x.w !== w.w; });
        var opts = shuffle(pick(same, 3).concat([w]));
        return {w:w, opts:opts, answered:null};
      });
      quiz = {qs:qs, i:0, score:0, setN:state.set, vibe:state.vibe, custom: !!quizPool};
      quizPool = null;
    }
    function renderQuiz(stage){
      if(quizPool || !quiz || (!quiz.custom && (quiz.setN !== state.set || quiz.vibe !== state.vibe))) newQuiz();
      stage.appendChild(el("h2","section-h", quiz.custom ? "Fixing Your Weak Words" : "Fill in the Blank"));
      stage.appendChild(el("p","section-p", (quiz.custom ? "Only the words you have missed, back in context. " : "Ten sentences from Set " + state.set + ". ") + "Read the whole sentence first and decide what kind of word has to go in the gap, positive or negative, before you look at anything else. Switch to No hints when you want to test real recall rather than recognition, which is the harder and more useful direction."));

      var box = el("div","quiz");

      if(quiz.i >= quiz.qs.length){
        var done = el("div","qcard");
        var pct = Math.round(quiz.score / quiz.qs.length * 100);
        done.appendChild(el("h3","section-h", quiz.score + " out of " + quiz.qs.length));
        done.appendChild(el("p","section-p",
          pct >= 90 ? "Genuinely excellent. Move to the next set." :
          pct >= 70 ? "Solid. Run the missed ones through Flashcards, then try again." :
          "This set needs another pass. Do Flashcards first, then come back."));
        var wrongs = quiz.qs.filter(function(q){ return q.answered && q.answered !== q.w.w; });
        if(wrongs.length){
          var g = el("div","wordchips");
          wrongs.forEach(function(q){
            var chip = el("span","wc", q.w.w);
            chip.title = q.w.d;
            g.appendChild(chip);
          });
          done.appendChild(el("p","section-p","Missed: "));
          done.appendChild(g);
        }
        var again = el("button","btn primary","New round");
        again.style.marginTop = "16px";
        again.onclick = function(){ quiz = null; quizPool = null; newQuiz(); render(); };
        done.appendChild(again);
        box.appendChild(done);
        stage.appendChild(box);
        return;
      }

      var q = quiz.qs[quiz.i];
      var card = el("div","qcard");

      var head = el("div","score");
      head.appendChild(el("span","counter","Question " + (quiz.i+1) + " of " + quiz.qs.length));
      var sw = el("div","qmode");
      [["choices","Choices"],["type","No hints"]].forEach(function(pair){
        var b = el("button","", pair[1]);
        b.setAttribute("aria-pressed", String(state.qstyle === pair[0]));
        b.onclick = function(){ state.qstyle = pair[0]; save(); render(); };
        sw.appendChild(b);
      });
      head.appendChild(sw);
      head.appendChild(el("span","counter","Score " + quiz.score));
      card.appendChild(head);

      var parts = q.w.b.split("____");
      var sent = el("p","qsent");
      sent.appendChild(document.createTextNode(parts[0]));
      var blank = el("span","blank", q.answered ? q.answered : "    ");
      sent.appendChild(blank);
      sent.appendChild(document.createTextNode(parts[1] || ""));
      card.appendChild(sent);

      if(state.qstyle === "type"){
        var row = el("div","typerow");
        var input = el("input");
        input.type = "text";
        input.setAttribute("autocomplete","off");
        input.setAttribute("autocapitalize","off");
        input.setAttribute("spellcheck","false");
        input.placeholder = "Type the word that fills the gap";
        input.setAttribute("aria-label","Type the word that fills the gap");
        if(q.answered){
          input.value = q.answered;
          input.disabled = true;
          input.className = (q.answered === q.w.w) ? "right" : "wrong";
        }
        var submit = el("button","btn primary","Check");
        function grade(){
          var v = (input.value || "").trim().toLowerCase();
          if(!v) return;
          var ok = (v === q.w.w) || (q.w.f && v === q.w.f.toLowerCase());
          q.answered = ok ? q.w.w : v;
          if(ok){ quiz.score++; markRight(q.w.w); } else { markWrong(q.w.w); }
          render();
        }
        submit.onclick = grade;
        input.onkeydown = function(e){ if(e.key === "Enter"){ e.preventDefault(); grade(); } };
        if(!q.answered){ row.appendChild(input); row.appendChild(submit); }
        else { row.appendChild(input); }
        card.appendChild(row);

        if(!q.answered){
          var hl = el("div","hintline");
          hl.appendChild(el("b","","Stuck?"));
          hl.appendChild(document.createTextNode(q.w.w.length + " letters, starts with"));
          hl.appendChild(el("u","", q.w.w.charAt(0)));
          var give = el("button","btn","Show me");
          give.style.padding = "3px 10px"; give.style.fontSize = "12px";
          give.onclick = function(){ q.answered = "(skipped)"; markWrong(q.w.w); render(); };
          hl.appendChild(give);
          card.appendChild(hl);
        }
        box.appendChild(card);
        quizTail(box, q);
        stage.appendChild(box);
        setTimeout(function(){ if(!q.answered) input.focus(); }, 30);
        return;
      }

      var opts = el("div","opts");
      q.opts.forEach(function(o){
        var b = el("button","opt");
        b.appendChild(el("b","", o.w));
        b.appendChild(el("small","", o.d));
        if(q.answered){
          b.disabled = true;
          if(o.w === q.w.w) b.className = "opt right";
          else if(o.w === q.answered) b.className = "opt wrong";
        } else {
          b.onclick = function(){
            q.answered = o.w;
            if(o.w === q.w.w){ quiz.score++; markRight(q.w.w); } else { markWrong(q.w.w); }
            render();
          };
        }
        opts.appendChild(b);
      });
      card.appendChild(opts);
      box.appendChild(card);
      quizTail(box, q);
      stage.appendChild(box);
    }

    function quizTail(box, q){
      if(!q.answered) return;
      var right = q.answered === q.w.w;
      var fb = el("div","feedback " + (right ? "right" : "wrong"));
      fb.appendChild(el("b","", right ? "Yes. " : "It was " + q.w.w + ". "));
      fb.appendChild(document.createTextNode((POSNAME[q.w.p]||q.w.p) + ", meaning " + q.w.d + "."));
      if(!right && q.w.conf) fb.appendChild(document.createTextNode(" Do not mix it up with " + q.w.conf.join(" or ") + "."));
      box.appendChild(fb);
      var nxt = el("button","btn primary", quiz.i === quiz.qs.length-1 ? "See my score" : "Next question");
      nxt.onclick = function(){ quiz.i++; render(); };
      box.appendChild(nxt);
    }

    /* ---------------------------------------------------- match */
    var match = null;
    function newMatch(){
      var pool = curSet().words.filter(function(w){ return !state.vibe || w.v === state.vibe; });
      var chosen = pick(pool, Math.min(6, pool.length));
      match = {pairs:chosen, defs:shuffle(chosen), sel:null, done:{}, tries:0, setN:state.set, vibe:state.vibe};
    }
    function renderMatch(stage){
      if(!match || match.setN !== state.set || match.vibe !== state.vibe) newMatch();
      stage.appendChild(el("h2","section-h","Match"));
      stage.appendChild(el("p","section-p","Six words, six meanings, scrambled. Click a word, then click its meaning. Wrong pairs shake and stay on the board."));

      var grid = el("div","matchgrid");
      var left = el("div","mcol"), right = el("div","mcol");

      match.pairs.forEach(function(w){
        var b = el("button","mitem" + (match.done[w.w] ? " done" : "") + (match.sel === w.w ? " sel" : ""));
        b.appendChild(el("b","", w.w));
        if(match.done[w.w]) b.disabled = true;
        else b.onclick = function(){ match.sel = (match.sel === w.w ? null : w.w); render(); };
        left.appendChild(b);
      });

      match.defs.forEach(function(w){
        var b = el("button","mitem" + (match.done[w.w] ? " done" : ""), w.d);
        if(match.done[w.w]) b.disabled = true;
        else b.onclick = function(){
          if(!match.sel) return;
          match.tries++;
          if(match.sel === w.w){
            match.done[w.w] = true; match.sel = null;
            markRight(w.w);
            render();
          } else {
            b.classList.add("bad");
            markWrong(match.sel); match.sel = null;
            setTimeout(function(){ render(); }, 340);
          }
        };
        right.appendChild(b);
      });

      grid.appendChild(left); grid.appendChild(right);
      stage.appendChild(grid);

      var bar = el("div","deckbar"); bar.style.marginTop = "16px";
      var solved = Object.keys(match.done).length;
      bar.appendChild(el("span","counter", solved + " of " + match.pairs.length + " matched · " + match.tries + " tries"));
      var nb = el("button","btn" + (solved === match.pairs.length ? " primary" : ""), solved === match.pairs.length ? "Six more →" : "New six");
      nb.onclick = function(){ newMatch(); render(); };
      bar.appendChild(nb);
      stage.appendChild(bar);
    }

    /* ---------------------------------------------------- opposite pairs */
    function renderOpposites(stage){
      stage.appendChild(el("h2","section-h","Opposite Pairs"));
      stage.appendChild(el("p","section-p","Thirty one pairs from this list that sit at opposite ends of the same idea, checked by hand. Learning a word beside its opposite beats learning it alone, because you store a contrast rather than a lone fact, and a contrast is much harder to lose."));

      (D.opposites || []).forEach(function(g){
        var box = el("div","opgroup");
        box.appendChild(el("h3","", g.t));
        var list = el("div","oplist");
        g.p.forEach(function(pair){
          var a = BY[pair[0]], b = BY[pair[1]];
          if(!a || !b) return;
          var row = el("div","oprow");
          var L = el("div","opside a");
          L.appendChild(el("b","", a.w)); L.appendChild(el("span","", a.d));
          var M = el("span","opvs","vs");
          var R = el("div","opside b");
          R.appendChild(el("b","", b.w)); R.appendChild(el("span","", b.d));
          row.appendChild(L); row.appendChild(M); row.appendChild(R);
          list.appendChild(row);
        });
        box.appendChild(list);
        stage.appendChild(box);
      });
    }

    /* ---------------------------------------------------- weak words */
    function renderWeak(stage){
      var weak = weakList();
      stage.appendChild(el("h2","section-h","Words to Fix"));
      stage.appendChild(el("p","section-p","Every word you have gotten wrong, hardest first. This is the highest value page here. Most of the score you have left to gain is sitting in this short list, not in the nine hundred words you already half know. A word leaves the pile the moment you get it right again."));

      if(!weak.length){
        stage.appendChild(el("p","empty","Nothing missed yet. Run a quiz, a match, or a speed drill, and anything you get wrong lands here on its own."));
        return;
      }

      var bar = el("div","deckbar");
      bar.style.justifyContent = "flex-start";
      bar.style.marginBottom = "18px";
      var d1 = el("button","btn primary","Quiz just these");
      d1.onclick = function(){ quiz = null; quizPool = weak.slice(0, 12); state.mode = "quiz"; render(); };
      var d2 = el("button","btn","Flashcard just these");
      d2.onclick = function(){ deck = {list: shuffle(weak), i:0, flipped:false, setN:"weak", vibe:"weak"}; state.mode = "cards"; render(); };
      var d3 = el("button","btn","Clear the pile");
      d3.onclick = function(){ state.miss = {}; save(); render(); };
      bar.appendChild(d1); bar.appendChild(d2); bar.appendChild(d3);
      stage.appendChild(bar);

      var grid = el("div","cards");
      weak.forEach(function(w){
        var c = el("article","misscard");
        var head = el("div","whead");
        head.appendChild(el("span","word", w.w));
        head.appendChild(el("span","pos", POSNAME[w.p] || w.p));
        head.appendChild(el("span","missn", "missed " + state.miss[w.w] + (state.miss[w.w] > 1 ? " times" : " time")));
        c.appendChild(head);
        c.appendChild(el("p","def", w.d));
        c.appendChild(exampleNode(w));
        var xb = extrasBlock(w);
        if(xb){ xb.style.paddingLeft = "0"; c.appendChild(xb); }
        var f = el("div","cfoot"); f.style.paddingLeft = "0";
        f.appendChild(el("span","vtag","Set " + w.set));
        var fixed = el("button","star","I know it now");
        fixed.onclick = function(){ markRight(w.w); render(); };
        f.appendChild(fixed);
        c.appendChild(f);
        grid.appendChild(c);
      });
      stage.appendChild(grid);
    }

    /* ---------------------------------------------------- speed drill */
    var drill = null, drillTimer = null;
    function stopDrill(){ if(drillTimer){ clearInterval(drillTimer); drillTimer = null; } }
    function newDrill(){
      var pool = curSet().words.filter(function(w){ return !state.vibe || w.v === state.vibe; });
      drill = {pool:pool, left:60, score:0, q:null, running:false, flash:null, setN:state.set, vibe:state.vibe};
      nextDrill();
    }
    function nextDrill(){
      var pool = drill.pool;
      var target = pool[Math.floor(Math.random() * pool.length)];
      var others = pool.filter(function(x){ return x.w !== target.w; });
      drill.q = {t: target, opts: shuffle(pick(others, 3).concat([target]))};
      drill.flash = null;
    }
    function startDrill(){
      drill.running = true;
      stopDrill();
      drillTimer = setInterval(function(){
        drill.left--;
        if(drill.left <= 0){
          drill.left = 0; stopDrill(); drill.running = false;
          if(drill.score > state.best){ state.best = drill.score; save(); }
        }
        if(state.mode === "drill") render();
      }, 1000);
      render();
    }
    function renderDrill(stage){
      if(!drill || drill.setN !== state.set || drill.vibe !== state.vibe){ stopDrill(); newDrill(); }
      stage.appendChild(el("h2","section-h","Speed Drill"));
      stage.appendChild(el("p","section-p","Sixty seconds, and this time you get the meaning and have to produce the word. That is the hard direction, and it is the one that builds real recall rather than vague recognition. The test is timed, so practicing under a clock is not a gimmick. Anything you miss goes straight to Words to Fix."));

      var box = el("div","drill");

      var t = el("div","timer");
      t.appendChild(el("div","big" + (drill.left <= 10 ? " low" : ""), String(drill.left)));
      var lw = el("div"); lw.appendChild(el("div","lbl","seconds left"));
      t.appendChild(lw);
      var sc = el("div","sc");
      sc.appendChild(el("b","", String(drill.score)));
      sc.appendChild(el("div","lbl","correct · best " + state.best));
      t.appendChild(sc);
      box.appendChild(t);

      if(drill.left <= 0){
        var over = el("div","prompt");
        over.appendChild(el("div","lbl","time"));
        over.appendChild(el("div","txt", drill.score + (drill.score === 1 ? " word" : " words") +
          (drill.score > 0 && drill.score >= state.best ? ". New personal best." : ".")));
        box.appendChild(over);
        var go = el("button","btn primary","Run it again");
        go.onclick = function(){ stopDrill(); newDrill(); startDrill(); };
        box.appendChild(go);
        stage.appendChild(box);
        return;
      }

      if(!drill.running){
        var start = el("div","prompt");
        start.appendChild(el("div","lbl","Set " + state.set + (state.vibe ? " · " + vibeOf(state.vibe).t : "")));
        start.appendChild(el("div","txt","Ready when you are."));
        box.appendChild(start);
        var b = el("button","btn primary","Start the clock");
        b.onclick = function(){ startDrill(); };
        box.appendChild(b);
        stage.appendChild(box);
        return;
      }

      var p = el("div","prompt");
      p.appendChild(el("div","lbl","which word means"));
      p.appendChild(el("div","txt", drill.q.t.d));
      box.appendChild(p);

      var opts = el("div","wordopts");
      drill.q.opts.forEach(function(o){
        var b = el("button","wopt", o.w);
        if(drill.flash){
          b.disabled = true;
          if(o.w === drill.q.t.w) b.className = "wopt right";
          else if(o.w === drill.flash) b.className = "wopt wrong";
        } else {
          b.onclick = function(){
            if(o.w === drill.q.t.w){
              drill.score++; markRight(o.w); nextDrill(); render();
            } else {
              markWrong(drill.q.t.w); drill.flash = o.w; render();
              setTimeout(function(){ if(drill && drill.running){ nextDrill(); render(); } }, 750);
            }
          };
        }
        opts.appendChild(b);
      });
      box.appendChild(opts);
      stage.appendChild(box);
    }

    /* ---------------------------------------------------- root flowers */
    function renderRoots(stage){
      stage.appendChild(el("h2","section-h","Root Flowers"));
      stage.appendChild(el("p","section-p","Forty-two Latin and Greek roots, each one drawn with the SAT words that grow out of it. Learning a root is the closest thing to cheating that the test allows: one root can unlock six or seven words at once, including words you have never seen. Petals in pink are on your list. The words underneath are free extras from the same family."));

      var note = el("div","note");
      note.appendChild(document.createTextNode("How to use this page: pick one flower a day. Say the root and its meaning out loud, then cover the petals and try to guess what each word means from the root alone. You will be right more often than you expect, and being right that way is what makes it stick."));
      stage.appendChild(note);

      var grid = el("div","rootgrid");
      FAMS.forEach(function(f){
        var card = el("div","flowercard");
        var head = el("div","whead");
        head.appendChild(el("span","word", f.e + " " + f.r));
        card.appendChild(head);

        var petals = f.on.slice(0, 9);
        var wrapEl = el("div","flower");
        var svgNS = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("viewBox","0 0 100 100");
        svg.setAttribute("preserveAspectRatio","none");
        wrapEl.appendChild(svg);

        var n = petals.length;
        petals.forEach(function(word, i){
          var ang = (i / n) * Math.PI * 2 - Math.PI / 2;
          var cx = 50 + Math.cos(ang) * 44;
          var cy = 50 + Math.sin(ang) * 37;
          var line = document.createElementNS(svgNS, "line");
          line.setAttribute("x1","50"); line.setAttribute("y1","50");
          line.setAttribute("x2", String(cx)); line.setAttribute("y2", String(cy));
          line.setAttribute("stroke","var(--line-2)");
          line.setAttribute("stroke-width","0.5");
          line.setAttribute("vector-effect","non-scaling-stroke");
          svg.appendChild(line);

          var chip = el("div","petal", word);
          chip.style.left = cx + "%";
          chip.style.top = cy + "%";
          var wd = BY[word];
          if(wd) chip.title = wd.d;
          wrapEl.appendChild(chip);
        });

        var core = el("div","core");
        core.appendChild(el("div","rt", f.r));
        core.appendChild(el("div","rm", f.m));
        wrapEl.appendChild(core);
        card.appendChild(wrapEl);

        if(f.bonus && f.bonus.length){
          var b = el("p","bonus");
          b.appendChild(el("b","", "Same family: "));
          b.appendChild(document.createTextNode(f.bonus.join(", ")));
          card.appendChild(b);
        }
        grid.appendChild(card);
      });
      stage.appendChild(grid);
    }

    /* ---------------------------------------------------- vibe index */
    function renderVibes(stage){
      stage.appendChild(el("h2","section-h","The Vibe Index"));
      stage.appendChild(el("p","section-p","All 1000 words re-sorted by what they feel like rather than how they are spelled. Studying in mood groups works because the SAT rarely asks for a precise definition. It asks whether the word is a compliment or an insult, and words that live in the same emotional neighborhood defend each other in your memory. Hover any word to see its meaning."));

      var groups = {};
      ALL.forEach(function(w){ (groups[w.v] = groups[w.v] || []).push(w); });
      var keys = Object.keys(groups).sort(function(a,b){
        if(a === "neutral") return 1; if(b === "neutral") return -1;
        return groups[b].length - groups[a].length;
      });

      keys.forEach(function(k){
        var v = vibeOf(k);
        var g = el("div","vgroup");
        var h = el("h3");
        h.appendChild(document.createTextNode(v.e + " " + v.t));
        var cnt = el("span","counter", groups[k].length + " words");
        h.appendChild(cnt);
        g.appendChild(h);
        g.appendChild(el("p","", v.s));
        var chips = el("div","wordchips");
        groups[k].sort(function(a,b){ return a.w < b.w ? -1 : 1; }).forEach(function(w){
          var c = el("span","wc", w.w);
          c.title = w.d;
          c.style.borderColor = "color-mix(in srgb, " + v.c + " 30%, transparent)";
          chips.appendChild(c);
        });
        g.appendChild(chips);
        stage.appendChild(g);
      });
    }

    /* ---------------------------------------------------- render */
    function render(){
      buildSpine();
      buildVibeBar();
      document.querySelectorAll(".mode").forEach(function(b){
        b.setAttribute("aria-pressed", String(b.dataset.mode === state.mode));
      });
      document.getElementById("searchField").style.display = (state.mode === "study") ? "flex" : "none";
      var stage = document.getElementById("stage");
      stage.textContent = "";
      if(state.mode === "study") renderStudy(stage);
      else if(state.mode === "cards") renderCards(stage);
      else if(state.mode === "quiz") renderQuiz(stage);
      else if(state.mode === "match") renderMatch(stage);
      else if(state.mode === "drill") renderDrill(stage);
      else if(state.mode === "weak") renderWeak(stage);
      else if(state.mode === "opp") renderOpposites(stage);
      else if(state.mode === "roots") renderRoots(stage);
      else if(state.mode === "vibes") renderVibes(stage);
      else if(state.mode === "notes") renderNotes(stage);
      refreshCount();
    }

    document.querySelectorAll(".mode").forEach(function(b){
      b.onclick = function(){ if(b.dataset.mode !== "drill") stopDrill(); state.mode = b.dataset.mode; render(); };
    });
    var st;
    document.getElementById("search").addEventListener("input", function(){
      clearTimeout(st); st = setTimeout(function(){ if(state.mode === "study") render(); }, 160);
    });
    document.getElementById("themeBtn").onclick = function(){
      var r = document.documentElement;
      var cur = r.getAttribute("data-theme");
      if(!cur){ cur = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"; }
      r.setAttribute("data-theme", cur === "dark" ? "light" : "dark");
    };

    render();
    })();

  };
})();
